import React from 'react';
import config from '../../../config';
import styles from './logo-link.module.scss';
import { ReactComponent as ZicassoLogo } from '../../../assets/svg/zicasso_logo_black.svg';
import { LogoLinkProps } from '../types';

const LogoLink = ({
  onClick,
}: LogoLinkProps) => (
  <a
    aria-label="Zicasso logo - Home Page"
    className={styles['logo-link']}
    onClick={onClick}
    href={config.Z3_URL}
    target="_blank"
    rel="noopener noreferrer"
  >
    <ZicassoLogo aria-hidden />
  </a>
);

export default LogoLink;
